import { render } from "./infos.vue?vue&type=template&id=02029fad&scoped=true"
import script from "./infos.vue?vue&type=script&lang=js"
export * from "./infos.vue?vue&type=script&lang=js"

import "./infos.vue?vue&type=style&index=0&id=02029fad&lang=scss&scoped=true"

import exportComponent from "D:\\javaScript\\ezhai_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02029fad"]])

export default __exports__